export const companySizeList = [
    "1-10 employees",
    "10-30 employees",
    "30-70 employees",
    "70-100 employees",
    "100+ employees"
]

export const title = "PetsMates"